import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
interface CountdownProps {
  className?: string;
}
export function Countdown({
  className = ''
}: CountdownProps) {
  // Start at 23:55:57
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 55,
    seconds: 57
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className={`flex items-center justify-center gap-2 font-mono text-2xl md:text-4xl font-bold text-red-600 ${className}`} data-id="element-34">
      <Clock className="w-6 h-6 md:w-8 md:h-8" data-id="element-35" />
      <span data-id="element-36">{format(timeLeft.hours)} HS</span>
      <span className="text-gray-400" data-id="element-37">:</span>
      <span data-id="element-38">{format(timeLeft.minutes)} MIN</span>
      <span className="text-gray-400" data-id="element-39">:</span>
      <span data-id="element-40">{format(timeLeft.seconds)} SEG</span>
    </div>;
}